<template>
  <div class="project-list">
    <div class="row no-gutters">
      <div
        class="project-item col-12 col-md-6"
        v-for="(item, index) in list"
        :key="index"
        @click="navigateTo(item)"
      >
        <div class="card mx-auto">
          <img
            :src="`${baseUrl}/uploadFile/pictureView.htm?id=${item.pictureId}`"
            class="cover"
            alt
          />

          <h6 class="name px-3 text-truncate">
            {{ item.projectName }}
          </h6>
          <p class="type px-3 text-truncate">类别：{{ item.projectType }}</p>
          <div class="bottom px-3">
            <p class="price">预算：￥{{ item.budget }}</p>
            <p class="date">
              {{ item.releaseTime && format(item.releaseTime.time) }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="pagination" v-if="isShowPagination">
      <button
        class="pagination-button mr-5"
        v-if="hasLast"
        @click.prevent.stop="last"
      >
        上一页
      </button>
      <button
        class="pagination-button"
        v-if="hasNext"
        @click.prevent.stop="next"
      >
        下一页
      </button>
    </div>
  </div>
</template>
<script>
import { formatDate } from '@/common/utils';
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    },
    isShowPagination: {
      type: Boolean,
      default: false
    },
    hasNext: {
      type: Boolean,
      default: false
    },
    hasLast: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    navigateTo(project) {
      console.log(project);

      this.$router.push({
        name: 'projectDetail',
        query: { name: project.projectName, id: project.id }
      });
    },
    next() {
      this.$emit('next');
    },
    last() {
      this.$emit('last');
    },
    format(timestamp) {
      return formatDate(timestamp);
    }
  }
};
</script>
<style lang="scss" scoped>
.project-list {
  .project-item {
    margin-bottom: 3rem;
    cursor: pointer;
    .card {
      border: solid 0.06rem #e5e5e5;
      width: 96%;
      text-align: left;
      overflow: hidden;
      .cover {
        margin-bottom: 1.5rem;
        // width: 34.38rem;
        // height: 20.44rem;
        width: 100%;
        height: auto;
        object-fit: cover;
      }
      .name {
        font-size: 1.38rem;
        color: #333333;
        margin-bottom: 1.5rem;
      }
      .type {
        font-size: 1.25rem;
        color: #666666;
        margin-bottom: 1.5rem;
      }
      .bottom {
        display: flex;
        justify-content: space-between;
        .price {
          font-size: 1.38rem;
          color: #333333;
        }
        .date {
          font-size: 1.25rem;
          color: #999999;
        }
      }
    }
  }
  .pagination {
    margin-bottom: 3rem;
    display: flex;
    justify-content: center;
    .pagination-button {
      padding: 0 15px;
      padding: 0.5rem 1.5rem;
      background-color: $acentColor;
      color: white;
      border: none;
      outline: none;
      font-size: 1rem;
      border-radius: 0.25rem;
      &:hover {
        background-color: rgba($color: $acentColor, $alpha: 0.9);
      }
      &:active {
        background-color: #771610;
      }
    }
  }
}
</style>
